@if (color(); as color) {<span class="repair-task-status" [ngClass]="color" [attr.data-status]="status()">{{ status() | repairTaskStatusTranslation }}</span>}
